import { render, staticRenderFns } from "./EmailAddressPage.vue?vue&type=template&id=d0acc7c4&"
import script from "./EmailAddressPage.vue?vue&type=script&lang=js&"
export * from "./EmailAddressPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0acc7c4')) {
      api.createRecord('d0acc7c4', component.options)
    } else {
      api.reload('d0acc7c4', component.options)
    }
    module.hot.accept("./EmailAddressPage.vue?vue&type=template&id=d0acc7c4&", function () {
      api.rerender('d0acc7c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/email/EmailAddressPage.vue"
export default component.exports